export default "<p>passsenger-detail works!</p>\n";